/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import Barcode from "react-barcode";
//import PerfectScrollbar from 'react-perfect-scrollbar';

// import Slider from "react-slick";

// import CardList from "../containers/card/CardList";
// import CardReg from "../containers/card/CardReg";

import { CopyToClipboard } from 'react-copy-to-clipboard';

class FriendAdd extends PureComponent {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;

    this._code();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _close = () => {
    const { setShowFriend } = this.props;
    setShowFriend(false);
  };

  _code = async () => {
    const { loginId } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
    } else {
      const result = await this._codeApi();
      const intReturn = result.data[0].intReturn;
      const codeData = result.data[0].listData;
      const chuchonCode = codeData[0].chuchonCode;

      if (intReturn === 0) {
        this.setState({
          chuchonCode,
        });
      }
    }
  };
  _codeApi = () => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/cashInfo', {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
      });
  };
  _onNaver = () => {
    const { chuchonCode } = this.state;
    const url =
      'https://www.aniplustv.com/aniplus2020Api/PG/appRcd.asp?code=' +
      chuchonCode;
    const title = '추천코드 공유';
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { chuchonCode } = this.state;
    const url =
      'https://www.aniplustv.com/aniplus2020Api/PG/appRcd.asp?code=' +
      chuchonCode;
    const title = '추천코드 공유';
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { chuchonCode } = this.state;
    const url =
      'https://www.aniplustv.com/aniplus2020Api/PG/appRcd.asp?code=' +
      chuchonCode;
    const title = '추천코드 공유';

    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  onInstar = () => {
    const { chuchonCode } = this.state;
    const url =
      'https://www.aniplustv.com/aniplus2020Api/PG/appRcd.asp?code=' +
      chuchonCode;
    // const title = "추천코드 공유";

    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { chuchonCode } = this.state;
    const url = 'https://www.aniplustv.com/fconde?code=' + chuchonCode;
    // const title = "추천코드 공유";

    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };

  render() {
    const { chuchonCode } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="detail_layer_pop">
          <div className="detail_view friendadd_view">
            <div className="detail_layer_close" onClick={this._close}>
              <img src={imgUrl + '/img/detail_img/close_1.png'} />
            </div>
            <div className="detail_view_layer">
              <div className="detil_top" id="top">
                <div className="friendadd_wrap">
                  <div className="main_visual">
                    <img
                      src={imgUrl + '/img/frendadd_main.png'}
                      alt="친구 추천하고 포인트 받자!"
                    />
                  </div>
                  <div className="main_copy">
                    <h3>
                      <span>추천 친구가</span>
                      <p>
                        멤버십 결제하면<em>!</em>
                      </p>
                    </h3>
                    <p className="sub">
                      내가 추천한 친구가 멤버십 결제하면
                      <br />
                      나도 3,000포인트~ 친구도 3,000포인트!
                    </p>
                  </div>
                  <div className="guide_wrap">
                    <ul className="guide_tit">
                      <li>
                        <p>추천해준사람</p>
                        <p className="big">나</p>
                        <p className="big_cash">
                          <b>3,000</b>포인트
                        </p>
                        <p>10명 추천 성공하면</p>
                        <p className="org">
                          삼만원 포인트 획득<em>!</em>
                        </p>
                      </li>
                      <li>
                        <img src={imgUrl + '/img/frendadd_img.png'} />
                        <p className="tit">참여방법</p>
                      </li>
                      <li>
                        <p>추천받은사람</p>
                        <p className="big">친구</p>
                        <p className="big_cash">
                          <b>3,000</b>포인트
                        </p>
                        <p>멤버십 결제하면</p>
                        <p className="org">
                          3,000 포인트 획득<em>!</em>
                        </p>
                      </li>
                    </ul>
                    <ul className="guide">
                      <li>
                        <p>
                          원하는 방법으로 친구에게
                          <br />
                          추천링크를 공유해주세요.
                        </p>
                      </li>
                      <li>
                        <p>
                          추천받은 친구가 정기결제 시<br />
                          추천코드를 입력합니다.
                        </p>
                      </li>
                      <li>
                        <p>
                          친구가 멤버십 결제하면
                          <br />
                          나도 친구도 각각
                          <br />
                          3,000포인트가 지급됩니다.
                        </p>
                      </li>
                      <li>
                        <p>
                          지급된 포인트는 바로
                          <br />
                          온/오프라인 모두
                          <br />
                          사용가능합니다.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="code_wrap">
                    <p className="tit">내 친구 추천 코드</p>
                    <CopyToClipboard
                      text={chuchonCode}
                      onCopy={() => {
                        alert('추천 코드가 클립보드에 카피되었습니다.');
                      }}
                    >
                      <div className="code" style={{ fontSize: 20 }}>
                        <img
                          src={imgUrl + '/img/frendadd_copy.png'}
                          alt="복사"
                          className="copy"
                        />
                        <span>{chuchonCode}</span>
                      </div>
                    </CopyToClipboard>
                    <p>원하는 방법으로 친구에게 추천링크를 공유해주세요.</p>
                  </div>
                  <div className="sns">
                    <a onClick={this._onFacebook} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/frendadd_btn1.png'}
                        alt="페이스북"
                      />
                    </a>
                    <a onClick={this._onTwitter} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/frendadd_btn2.png'}
                        alt="트위터"
                      />
                    </a>
                    <a onClick={this._onKakao} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/frendadd_btn3.png'}
                        alt="카카오톡"
                      />
                    </a>
                    <CopyToClipboard
                      text={
                        'https://www.aniplustv.com/aniplus2020Api/PG/appRcd.asp?code=' +
                        chuchonCode
                      }
                      onCopy={() => {
                        alert('추천 링크가 클립보드에 카피되었습니다.');
                      }}
                    >
                      <a style={{ cursor: 'pointer' }}>
                        <img
                          src={imgUrl + '/img/frendadd_btn4.png'}
                          alt="링크"
                        />
                      </a>
                    </CopyToClipboard>
                  </div>
                  <div className="notice">
                    <h3>알아두세요</h3>
                    <ul>
                      <li>추천인은 애니플러스의 회원이어야합니다.</li>
                      <li>지급된 포인트는 3개월간 사용이 가능합니다.</li>
                      <li>
                        멤버십 결제자와 추천인이 동일할 경우포인트를 받을 수
                        없습니다.
                      </li>
                      <li>
                        포인트는 다른 결제 수단과 병행하여 사용 가능합니다.
                        <br />
                        단, 행사/타이틀/상품 등에 따라 포인트 사용이 불가할 수
                        있습니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FriendAdd));
